import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { StockComponent } from './pages/stock/stock.component'; 
import { ReservationsComponent } from './pages/reservations/reservations.component';
import { ReservationsAddComponent } from './pages/reservations-add/reservations-add.component';
import { OrderComponent } from './pages/order/order.component';
import { OrderAddComponent } from './pages/order-add/order-add.component';
import { LoginComponent } from './pages/login/login.component';

import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  { path: 'stock', component: StockComponent, canActivate: [AuthGuard]},
  { path: 'reservations', component: ReservationsComponent, canActivate: [AuthGuard]},
  { path: 'reservations/new', component: ReservationsAddComponent, canActivate: [AuthGuard]},
  { path: 'sale', component: OrderComponent, canActivate: [AuthGuard]},
  { path: 'sale/:id', component: OrderComponent, canActivate: [AuthGuard]},
  { path: 'salenew', component: OrderAddComponent, canActivate: [AuthGuard]},
  { path: 'login', component: LoginComponent}
];

@NgModule({
  exports: [ RouterModule ],
  imports: [ RouterModule.forRoot(routes) ]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// C:/Users/krist/source/repos/FoodButtler.App/src/app/app-routing.module.ts